import React from 'react'
import { Redirect } from 'react-router-dom'

export default function RedirectToGetQuote() {
  return (
    <Redirect to="get-quote" />
  )
}
